// Shared question types for check-in cycles — reusable by performance
// cycles (today) and check-in cycles (later).

export type RatingScaleLabel = {
  labelName: string
  labelSlug: string
  description: string
  color: string
  scaleValue: number
}

export type QuestionType = 'open_dialogue' | 'rating_scale'

export type Team = {
  id: number
  name: string
}

export type CheckinQuestion = {
  id: number
  body: string
  questionType: QuestionType
  position: number
  /** The team this question belongs to. null/undefined for org-wide defaults. */
  teamId?: number | null
}

export const TYPE_LABELS: Record<QuestionType, string> = {
  open_dialogue: 'Open-dialogue',
  rating_scale: 'Rating Scale',
}

// The question body comes from the rich-text editor as HTML, so comparing or
// testing it as-is is unreliable: a whitespace-only entry still carries
// `<p>…</p>` markup (and can contain `&nbsp;`), and the same visible wording
// can be wrapped in different markup. Strip tags and non-breaking spaces,
// trim, and lowercase, leaving plain text suitable for equality checks.
export const normalizeQuestionText = (html: string): string =>
  html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim()
    .toLowerCase()

// Returns false for empty / whitespace-only bodies.
export const hasVisibleText = (html: string): boolean =>
  normalizeQuestionText(html) !== ''
